import { Box, Paragraph } from 'grommet'
import styled from 'styled-components'

import { Link } from '@ui/links/Link'

export const ContentWrapper = styled(Box)`
  display: ${({ rowItems }) => (rowItems ? 'grid' : 'flex')};
  flex-flow: row wrap;
  grid-template-columns: repeat(${({ rowItems }) => rowItems}, auto);
  justify-content: space-between;
  width: 100%;
  ${({ theme }) => theme.below.tablet`
    grid-template-columns: repeat(1, auto);
    flex-direction: column;
  `}
  ${({ theme }) => theme.below.laptop`
    justify-content: center;
  `}
  ${({ theme }) => theme.above.laptopL`
    justify-content: space-around;
  `}
  ${({ theme }) => theme.below.mobileXL`
    .container:last-child {
        margin-bottom :0;
      }
  `}
`

export const Content = styled(Box)`
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  display: flex;
  padding: ${({ theme }) => theme.newSpaces.md}px;
  transition: transform ease 0.3s;
  width: 33%;

  ${({ theme }) => theme.below.laptop`
    padding: ${theme.newSpaces.xs2}px;
  `}

  ${({ theme }) => theme.below.laptopL`
    margin-right: 0;
    padding: ${({ theme }) => theme.newSpaces.md}px ${({ theme }) =>
    theme.newSpaces.md}px ${({ theme }) => theme.newSpaces.md}px 0;
  `}

  ${({ theme }) => theme.below.tablet`
    width: 100%;
    max-width: 100%;
    margin: ${theme.newSpaces.xs}px ${theme.newSpaces.xs3}px;
    align-items: center;
  `}

  ${({ theme, hover }) =>
    hover &&
    `&:hover{
      background-color: ${theme.newColors.hoverLightGray};
    }`}
  
  &:hover {
    transform: ${({ uplift }) => (uplift ? 'translate(0, -20px)' : '')};
  }
`

export const Title = styled(Link)`
  align-self: flex-start;
  color: ${({ theme }) => theme.colors.secondary};
  font-size: ${({ theme }) => theme.fontSizes[4]}px;
  font-weight: ${({ theme }) => theme.fontWeight[7]};
  line-height: ${({ theme }) => theme.lineHeight[1]}px;
  margin-left: ${({ $oneRow }) => ($oneRow ? '12px' : '0px')};
  white-space: pre-wrap;

  ${({ theme }) => theme.below.laptop`
    font-size: ${theme.fontSizes[3]}px;
  `}
  ${({ theme }) => theme.below.tablet`
    text-align: ${({ $oneRow }) => ($oneRow ? 'initial' : 'center')};
    width: ${({ $oneRow }) => ($oneRow ? 'auto' : '100%')};
    font-size:  ${theme.fontSizes[3]}px;
    line-height:  ${theme.lineHeight[0]}px;
    white-space: wrap;
  `}
  &:hover {
    text-decoration: underline;
    text-decoration-color: ${({ theme, $titleLink }) =>
      $titleLink ? theme.colors.primary : 'transparent'};
    text-decoration-thickness: 2px;
    text-underline-offset: 2px;
  }

  ${({ theme }) => theme.below.tablet`
    width: ${({ $oneRow }) => ($oneRow ? 'auto' : '100%')};
    font-size:  ${theme.fontSizes[3]}px;
    line-height:  ${theme.lineHeight[0]}px;
  `}
`

export const Subtitle = styled(Paragraph)`
  color: ${({ theme }) => theme.colors.silver};
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  line-height: ${({ theme }) => theme.lineHeight[0]}px;
  margin-top: 0;
  white-space: normal;

  & > a {
    color: ${({ theme }) => theme.colors.primary};
  }

  .text-link a {
    color: ${({ theme }) => theme.colors.silver};
    font-size: ${({ theme }) => theme.fontSizes[2]}px;
    font-weight: ${({ theme }) => theme.fontWeight[2]};
    line-height: ${({ theme }) => theme.lineHeight[0]}px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      text-decoration-color: ${({ theme }) => theme.colors.primary};
      text-decoration-thickness: 2px;
      text-underline-offset: 2px;
    }
  }

  ${({ theme }) => theme.below.tablet`
    width: 100%;
    max-width: 100%;
    text-align: ${({ oneRow }) => (oneRow ? 'initial' : 'center')};
  `}

  ${({ theme }) => theme.below.laptopL`
    white-space: pre-wrap;
  `}

  ${({ theme }) => theme.below.laptop`
    white-space: normal;
  `}
`

export const BlockWrapper = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: ${({ $oneRow }) => ($oneRow ? 'row' : 'column')};
  margin: 0 0 ${({ theme }) => theme.spaces[3]}px;
  min-height: 60px;
  ${({ theme }) => theme.below.tablet`
    width: 100%;
    align-items: center;
  `}

  ${({ theme }) => theme.below.mobileXL`
    margin-bottom:0;
  `}
`

export const ImageWrapper = styled(Box)`
  align-self: flex-start;
  border: ${({ $borderColor }) =>
    $borderColor ? `2px solid ${$borderColor}` : 'none'};
  cursor: ${({ $titleLink }) => $titleLink && 'pointer'};
  display: flex;
  margin-bottom: ${({ theme }) => theme.newSpaces.xs + 4}px;
  overflow: hidden;

  img {
    object-fit: contain;
    width: auto;
  }
  ${({ theme }) => theme.below.tablet`
    margin-bottom: 0
  `}
`

export const HexagonImage = styled(Box)`
  left: -${({ theme }) => theme.newSpaces.xs}px;
  position: absolute;
  top: -${({ theme }) => theme.spaces[5] + theme.spaces[3]}px;

  & > svg > path {
    fill: transparent;
    transition: 0.1s all ease;

    &:hover {
      stroke-width: 8;
    }
  }

  ${({ theme }) => theme.below.laptopML`
    display: none;
  `}
`

export const LinkWrapper = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes[2]}px !important;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  margin-left: auto;
  margin-top: auto;
  padding-top: ${({ theme }) => theme.spaces[2]}px;

  &:hover {
    text-decoration: underline;
  }

  ${({ theme }) => theme.below.tablet`
    text-align: center;
  `}
`

export const TextContent = styled(Paragraph)`
  display: flex;
  font-size: ${({ theme }) => theme.fontSizes[0]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
`

export const TitleWrapper = styled.div`
  align-items: center;
  display: flex;
  height: ${({ titleHeight }) => titleHeight};
  margin: ${({ topMarginLink }) => topMarginLink && 'auto 0'};
  margin-top: ${({ oneRow }) => (oneRow ? '0px' : '20px')};
  overflow: hidden;
  text-overflow: ellipsis;
`
export const ExperienceSectionHorizontalHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;

  & ${ImageWrapper} {
    width: 85px;
  }
`
